import { generate } from "shortid";
import { PAGE_THEMES } from "../types";

export const PARTNER_PAYMENT_PAGES = {
  partner_payment__page: {
    id: `partner_payment__page-${generate()}`,
    type: "partner_payment_plan_type",
    backwards_navigation_enabled: false,
    title: null,
    module_name: null,
    target_state: null,
    target_field: null,
    target_pages: [],
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: null,
      description: null,
      image: null,
      options: [],
      default_progression: "partner_payment_success__page",
    },
  },
  partner_payment_success__page: {
    id: `partner_payment_success__page-${generate()}`,
    type: "partner_payment_success_type",
    backwards_navigation_enabled: false,
    title: null,
    module_name: null,
    target_state: null,
    target_field: null,
    target_pages: [],
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: `You're all set`,
      description: `Your subscription has started and your headset is on its way. You'll be emailed a tracking code within 2 business days`,
      image: "illustrations/joyful",
      default_progression: "partner_payment_download__page",
      options: [],
    },
  },
  partner_payment_download__page: {
    id: `partner_payment_download__page-${generate()}`,
    type: "partner_payment_download_type",
    backwards_navigation_enabled: false,
    title: null,
    module_name: "web_payment",
    target_field: null,
    target_pages: [],
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: `Download the mobile app and get started`,
      description: null,
      image: null,
      default_progression: null,
      options: [],
    },
  },
};
